import * as React from 'react'
import DialogTitle from '@mui/material/DialogTitle'
import Button from '@mui/material/Button'

import Grid from '@mui/material/Grid'

import Container from '@mui/material/Container'
import DialogContent from '@mui/material/DialogContent'
import IconButton from '@mui/material/IconButton'
import CloseIcon from '@mui/icons-material/Close'
import DialogContentText from '@mui/material/DialogContentText'
import DialogActions from '@mui/material/DialogActions'
import Dialog from '@mui/material/Dialog'
import LoadingButton from '@mui/lab/LoadingButton'
import Link from '@mui/material/Link'
import Paper from '@mui/material/Paper'
import Box from '@mui/material/Box'
import Divider from '@mui/material/Divider'

import Stepper from '@mui/material/Stepper'
import Step from '@mui/material/Step'
import StepLabel from '@mui/material/StepLabel'
import StepButton from '@mui/material/StepButton'

import Typography from '@mui/material/Typography'

import ArrowForwardIcon from '@mui/icons-material/ArrowForwardOutlined'
import TextFieldsIcon from '@mui/icons-material/TextFields'
import AddLinkIcon from '@mui/icons-material/AddLink'
import UploadFileOutlinedIcon from '@mui/icons-material/UploadFileOutlined'
import TableViewOutlinedIcon from '@mui/icons-material/TableViewOutlined'
import ImportExportIcon from '@mui/icons-material/ImportExport'
import CloudSyncOutlinedIcon from '@mui/icons-material/CloudSyncOutlined'

import EditableSelect from '../EditableSelect'
import TextField from '@mui/material/TextField'

import {
    useContextsStore,
    selectOwnedContexts,
} from '../../stores/useContextsStore'
import { UserContext } from '../../UserContext'

import { useTheme } from '@mui/material/styles'

import { SubImportContext } from './SubImportContext'
import { DialogsContext, DialogsProvider } from '../../DialogsContext'

import Select from '@mui/material/Select'
import MenuItem from '@mui/material/MenuItem'
import FormControl from '@mui/material/FormControl'
import InputLabel from '@mui/material/InputLabel'
import FormHelperText from '@mui/material/FormHelperText'
import FormLabel from '@mui/material/FormLabel'
import FormControlLabel from '@mui/material/FormControlLabel'

import Switch from '@mui/material/Switch'

import axios from 'axios'
import qs from 'qs'

import {
    slugifyString,
    convertGPTResponsesToArray,
    isValidUrl,
    getUrlTypeAndCode,
} from '../../utils/index'

import { sendToAnalytics } from '../../Analytics'
import { importErrorMessage } from './importError'


const steps = ['Start', 'Sources', 'Settings', 'Results']

export default function AllImportDialog({ presetContext = '', open, onClose }) {
    const theme = useTheme() // hook to get the current theme

    const {
        activeImportDialog,
        setActiveImportDialog,
        setBackLinkDialog,
        presetSearchString,
        setPresetSearchString,
        openImportDialog,
        closeImportDialog,
    } = React.useContext(DialogsContext)

    const {
        activeSubImportDialog,
        setActiveSubImportDialog,
    } = React.useContext(SubImportContext)

    const [selectedContext, setSelectedContext] = React.useState(presetContext)

    const [errorMessage, setErrorMessage] = React.useState(null)

    const [importError, setImportError] = React.useState(null)

    const [completedSteps, setCompletedSteps] = React.useState([])

    const [visitedContext, setVisitedContext] = React.useState(false)

    const [numberOfResults, setNumberOfResults] = React.useState('10')

    const [searchString, setSearchString] = React.useState(presetSearchString)

    const [modelToUse, setModelToUse] = React.useState('gpt4')

    const [hideSearchTerms, setHideSearchTerms] = React.useState(true)

    const [advancedSettings, setAdvancedSettings] = React.useState(false)

    const [fromInsideContext, setFromInsideContext] = React.useState(false)

    const [activeInputPanel, setActiveInputPanel] = React.useState(false)

    const { username } = React.useContext(UserContext)

    React.useEffect(() => {
        setActiveSubImportDialog(false)
        setBackLinkDialog('backLink')
    }, [])

    const contexts = useContextsStore(selectOwnedContexts)
    const contextNames = contexts.map(c => c.name)

    const [activeStep, setActiveStep] = React.useState(0)
    const [skipped, setSkipped] = React.useState(new Set())

    const isStepOptional = step => {
        return step === 1
    }

    const isStepSkipped = step => {
        return skipped.has(step)
    }

    const handleNext = () => {
        let newSkipped = skipped
        if (isStepSkipped(activeStep)) {
            newSkipped = new Set(newSkipped.values())
            newSkipped.delete(activeStep)
        }

        setActiveStep(prevActiveStep => prevActiveStep + 1)
        setSkipped(newSkipped)
    }

    const submitDataForm = () => {
        const forwardMode =
            modelToUse === 'gpt4' ? 'insight_gpt4' : 'insight_gpt3'

        const redirectUrl = fromInsideContext
            ? ``
            : `/${username}/${selectedContext}/edit?mode=${forwardMode}`

        const dataToSend = {
            context: selectedContext,
            addedContexts: selectedContext,
            mode: modelToUse === 'gpt4' ? 'gptchat' : 'continue',
            entry: { body: searchString },
            addedCategories: `[ideas]`,
            redirectUrl: redirectUrl,
        }

        const dataAsForm = qs.stringify(dataToSend)

        axios
            .post(`/post`, dataAsForm, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded', // Sending as URL-encoded form data
                },
            })
            .then(response => {
                if (response.data.redirectUrl) {
                    // If you're using window.location
                    window.location.href = response.data.redirectUrl

                    // Or, if you're using React Router's history (assuming you have access to the history object)
                    // history.push(response.data.redirectUrl);
                } else {
                    console.error(`Did't receive any response from the server.`)
                    if (response.data.error) {
                        setErrorMessage(
                            typeof response.data.error == 'object'
                                ? response.data.error.error ||
                                      JSON.stringify(response.data.error)
                                : response.data.error
                        )
                        setImportError(response.data.error)
                        setActiveStep(1)
                    }
                }
            })
            .catch(error => {
                // Handle the error here
                console.error('Received the following error', error)
                setErrorMessage(importErrorMessage(error))
                setImportError(response.data.error)
            })
    }

    const handleBack = () => {
        setActiveStep(prevActiveStep => prevActiveStep - 1)
    }

    const handleNumberOfResultsChange = event => {
        setNumberOfResults(event.target.value)
    }

    const handleSearchStringChange = event => {
        setSearchString(event.target.value)
    }

    const handleSearchLanguageChange = event => {
        setSearchLanguage(event.target.value)
    }

    const handleSearchCountryChange = event => {
        setSearchCountry(event.target.value)
    }

    const openTextEditImport = type => {
        if (type == 'shortTextImport') {
            setActiveInputPanel('shortTextImport')
        } else {
            setActiveSubImportDialog({})
            setActiveImportDialog(type)
        }

        sendToAnalytics({
            userId: username,
            event: 'choose_content_import_type',
            data: { importType: type },
        })
    }

    React.useEffect(() => {
        if (activeStep != 1) return
        if (activeInputPanel != 'shortTextImport') return

        if (!searchString) {
            setErrorMessage(
                `Please, add a text that you would like to analyze and visualize.`
            )
            setActiveStep(0)
            return
        }

        const numberOfWords = searchString.split(' ')

        const urlIsValid = isValidUrl(searchString)

        if (urlIsValid) {
            const urlTypeAndCode = getUrlTypeAndCode(searchString)

            setPresetSearchString(searchString)
            switch (urlTypeAndCode.type) {
                case 'amazon':
                    setActiveImportDialog('amazonReviews')
                    break
                case 'youtube':
                    setActiveImportDialog('youtubeSubtitles')
                    break
                case 'youtubeChannel':
                case 'youtubePlaylist':
                    setActiveImportDialog('youtubeChannel')
                    break
                case 'wikipedia':
                    setActiveImportDialog('urls')
                    break
                case 'twitter':
                    setActiveImportDialog('twitter')
                    break
                case 'rss':
                    setActiveImportDialog('rss')
                    break
                default:
                    setActiveImportDialog('urls')
                    break
            }
            setBackLinkDialog('backLinkToLinks')
            return
        }

        if (numberOfWords.length > 0 && numberOfWords.length < 16) {
            setPresetSearchString(searchString)
            setActiveImportDialog('shortTextImport')
            setBackLinkDialog('backLink')
            return
        }

        if (numberOfWords.length >= 16) {
            setPresetSearchString(searchString)
            setActiveImportDialog('textEditor')
            return
        }
    }, [activeStep])

    const handleStep = step => {
        setActiveStep(step)
    }

    return (
        <>
            <Dialog
                open={open}
                onClose={onClose}
                fullWidth={true}
                maxWidth="lg"
            >
                <DialogTitle
                    sx={{
                        padding: 4,
                        color: theme => theme.palette.text.primary,
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                    }}
                >
                    {'Choose the type of content to analyze'}
                    <IconButton
                        edge="end"
                        color="inherit"
                        onClick={onClose}
                        aria-label="close"
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <Stepper
                    activeStep={activeStep}
                    sx={{ paddingLeft: 4, paddingRight: 4, paddingTop: 2 }}
                >
                    {steps.map((label, index) => {
                        const stepProps = {}
                        const labelProps = {}
                        // if (isStepOptional(index)) {
                        //     labelProps.optional = (
                        //         <Typography variant="caption">
                        //             Optional
                        //         </Typography>
                        //     )
                        // }
                        if (isStepSkipped(index)) {
                            stepProps.completed = false
                        }
                        return (
                            <Step key={label} {...stepProps}>
                                <StepButton
                                    onClick={() => handleStep(index)}
                                    completed={(
                                        completedSteps.indexOf(index) >= 0
                                    ).toString()}
                                >
                                    <StepLabel
                                        {...labelProps}
                                        sx={{
                                            '& .MuiStepLabel-label': {
                                                fontSize: {
                                                    xs: '0.75rem',
                                                    sm: 'initial',
                                                },
                                            },
                                        }}
                                    >
                                        {label}
                                    </StepLabel>
                                </StepButton>
                            </Step>
                        )
                    })}
                </Stepper>

                {errorMessage && (
                    <Typography
                        sx={{
                            paddingRight: 4,
                            paddingLeft: 4,
                            paddingTop: 4,
                            paddingBottom: 0,
                        }}
                        color="error"
                        component="div"
                        gutterBottom
                    >
                        {errorMessage}
                    </Typography>
                )}

                {activeStep === 0 && (
                    <>
                        <DialogContent
                            sx={{
                                paddingRight: 4,
                                paddingLeft: 4,
                                paddingTop: 4,
                            }}
                        >
                            <Grid container spacing={8}>
                                <Grid item xs={12} sm={4}>
                                    {activeInputPanel === 'shortTextImport' && (
                                        <>
                                            <FormControl
                                                fullWidth
                                                sx={{ marginTop: 4 }}
                                            >
                                                <TextField
                                                    label={
                                                        'Add Text, Keywords, or URLs  Here'
                                                    }
                                                    value={searchString}
                                                    variant="outlined"
                                                    onChange={
                                                        handleSearchStringChange
                                                    }
                                                    onBlur={() => {
                                                        if (
                                                            !searchString ||
                                                            searchString.length <
                                                                1
                                                        ) {
                                                            setActiveInputPanel(
                                                                false
                                                            )
                                                        }
                                                    }}
                                                    aria-describedby="searchString-helperText"
                                                    multiline
                                                    autoFocus
                                                    rows={8} // This can be any number that will fit within 200px height
                                                    sx={{
                                                        '& .MuiOutlinedInput-root': {
                                                            height: '232px', // Set the height of the outer container of the input
                                                            '& .MuiInputBase-inputMultiline': {
                                                                height: '232px', // Set the height of the inner textarea
                                                                overflowY:
                                                                    'auto', // Enable scroll on overflow
                                                                // Remove extra padding if needed
                                                                padding:
                                                                    '0 !important',
                                                                boxShadow:
                                                                    'none !important',
                                                                border:
                                                                    'none !important',
                                                            },
                                                        },
                                                    }}
                                                />
                                            </FormControl>
                                        </>
                                    )}
                                    {activeInputPanel != 'shortTextImport' && (
                                        <Paper
                                            onClick={() =>
                                                openTextEditImport(
                                                    'shortTextImport'
                                                )
                                            }
                                            sx={{
                                                p: 2,
                                                display: 'flex',
                                                flexDirection: 'column',
                                                alignItems: 'center',
                                                textAlign: 'center',
                                                height: '200px',
                                                borderColor: 'primary.main',
                                                backgroundColor:
                                                    'background.default',
                                                cursor: 'pointer',
                                                marginTop: 4,
                                                opacity: activeInputPanel
                                                    ? 0.4
                                                    : 1,
                                            }}
                                        >
                                            <Box
                                                sx={{
                                                    display: 'flex',
                                                    flexDirection: 'row',
                                                    alignItems: 'center',
                                                    gap: 1, // Adjust this value as needed for spacing
                                                }}
                                            >
                                                <TextFieldsIcon
                                                    sx={{ color: '#0096ff' }}
                                                />
                                                <Divider
                                                    orientation="vertical"
                                                    flexItem
                                                />
                                                <AddLinkIcon
                                                    sx={{ color: '#0096ff' }}
                                                />
                                                <Typography variant="subtitle1">
                                                    Text or Links
                                                </Typography>
                                            </Box>
                                            <Typography
                                                sx={{ marginTop: 4 }}
                                                variant="body1"
                                            >
                                                Add plain text, keywords, or
                                                paste URLs here
                                            </Typography>
                                        </Paper>
                                    )}
                                </Grid>
                                <Grid item xs={12} sm={4}>
                                    <Paper
                                        onClick={() =>
                                            openTextEditImport(
                                                'textFilesImport'
                                            )
                                        }
                                        sx={{
                                            p: 2,
                                            display: 'flex',
                                            flexDirection: 'column',
                                            alignItems: 'center',
                                            textAlign: 'center',
                                            height: '200px',
                                            borderColor: 'primary.main',
                                            backgroundColor:
                                                'background.default',
                                            cursor: 'pointer',
                                            marginTop: 4,
                                            opacity:
                                                activeInputPanel ==
                                                'shortTextImport'
                                                    ? 0.4
                                                    : 1,
                                        }}
                                    >
                                        <Box
                                            sx={{
                                                display: 'flex',
                                                flexDirection: 'row',
                                                alignItems: 'center',
                                                gap: 1, // Adjust this value as needed for spacing
                                            }}
                                        >
                                            <UploadFileOutlinedIcon
                                                sx={{ color: '#17a93c' }}
                                            />
                                            <Divider
                                                orientation="vertical"
                                                flexItem
                                            />
                                            <TableViewOutlinedIcon
                                                sx={{ color: '#17a93c' }}
                                            />
                                            <Typography variant="subtitle1">
                                                File Upload
                                            </Typography>
                                        </Box>
                                        <Typography
                                            sx={{ marginTop: 4 }}
                                            variant="body1"
                                        >
                                            Upload a .csv spreadsheet, .pdf,
                                            .json, .gexf, .docx, .rtf, or .txt.
                                            files
                                        </Typography>
                                    </Paper>
                                </Grid>
                                <Grid item xs={12} sm={4}>
                                    <Paper
                                        onClick={() =>
                                            openTextEditImport('syncImport')
                                        }
                                        sx={{
                                            p: 2,
                                            display: 'flex',
                                            flexDirection: 'column',
                                            alignItems: 'center',
                                            textAlign: 'center',
                                            height: '200px',
                                            borderColor: 'primary.main',
                                            backgroundColor:
                                                'background.default',
                                            cursor: 'pointer',
                                            marginTop: 4,
                                            opacity:
                                                activeInputPanel ==
                                                'shortTextImport'
                                                    ? 0.4
                                                    : 1,
                                        }}
                                    >
                                        <Box
                                            sx={{
                                                display: 'flex',
                                                flexDirection: 'row',
                                                alignItems: 'center',
                                                gap: 1, // Adjust this value as needed for spacing
                                            }}
                                        >
                                            <ImportExportIcon
                                                sx={{ color: '#e50cd8' }}
                                            />
                                            <Divider
                                                orientation="vertical"
                                                flexItem
                                            />
                                            <CloudSyncOutlinedIcon
                                                sx={{ color: '#e50cd8' }}
                                            />
                                            <Typography variant="subtitle1">
                                                External Sources
                                            </Typography>
                                        </Box>
                                        <Typography
                                            sx={{ marginTop: 4 }}
                                            variant="body1"
                                        >
                                            Obsidian, Evernote, News, and other
                                            external sources
                                        </Typography>
                                    </Paper>
                                </Grid>
                            </Grid>
                        </DialogContent>
                    </>
                )}

                <DialogActions
                    sx={{
                        paddingRight: 4,
                        paddingLeft: 4,
                        paddingBottom: 4,
                        paddingTop: 2,
                    }}
                >
                    {/* <Button onClick={onClose} variant="outlined">
                        Cancel
                    </Button> */}

                    <LoadingButton
                        color="info"
                        variant="contained"
                        endIcon={<ArrowForwardIcon />}
                        disabled={!searchString || !searchString.length > 0}
                        onClick={handleNext}
                    >
                        {activeStep === steps.length - 1 ? 'Visualize' : 'Next'}
                    </LoadingButton>
                </DialogActions>
            </Dialog>
        </>
    )
}
